import React, { FunctionComponent } from 'react';

import {
  UI_SHAPE,
  UiShape,
} from '@savgroup-front-common/constants/shared/shape';
import { UI_SIZE, UiSize } from '@savgroup-front-common/constants/shared/size';
import { RoleHtmlAttribute } from '@savgroup-front-common/types/RoleHtmlAttribute';

import { CrossIcon } from '../../protons/icons/Cross';

import { $Tag, $TagCloseButton, $TagContent } from './Tag.styles';
import {
  TAG_TEXT_TRANSFORM,
  TAG_VARIANT,
  TagTextTransform,
  TagVariant,
} from './Tag.types';

export interface TagProps {
  noEllispis?: boolean;
  disabled?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  danger?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  neutral?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  alert?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  success?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  primary?: boolean;
  /**
   * @deprecated Use `variant` instead.
   */
  secondary?: boolean;
  withoutMargin?: boolean;
  fluid?: boolean;
  dataTestId?: string;
  isNaked?: boolean;
  /**
   * @deprecated Use `size` instead.
   */
  isSmall?: boolean;
  onClick?: (event: any) => void;
  onClose?: (event: any) => void;
  role?: RoleHtmlAttribute;
  isHollow?: boolean;
  hasZIndex?: boolean;
  title?: string;
  variant?: TagVariant;
  size?: UiSize;
  textTransform?: TagTextTransform;
  shape?: UiShape;
}

const Tag: FunctionComponent<React.PropsWithChildren<TagProps>> = ({
  children,
  disabled = false,
  danger = false,
  alert = false,
  success = false,
  primary = false,
  secondary = false,
  neutral = false,
  withoutMargin = false,
  fluid = false,
  dataTestId = 'tag',
  noEllispis = false,
  isNaked = false,
  isSmall = false,
  onClick,
  onClose,
  role,
  isHollow = false,
  hasZIndex = false,
  title,
  variant,
  size,
  textTransform,
  shape,
}) => {
  const resolvedVariant: TagVariant =
    variant ||
    (danger && TAG_VARIANT.DANGER) ||
    (alert && TAG_VARIANT.ALERT) ||
    (success && TAG_VARIANT.SUCCESS) ||
    (primary && TAG_VARIANT.PRIMARY) ||
    (secondary && TAG_VARIANT.SECONDARY) ||
    (neutral && TAG_VARIANT.NEUTRAL) ||
    TAG_VARIANT.DEFAULT;

  const resolvedSize: UiSize = size || (isSmall ? UI_SIZE.SM : UI_SIZE.MD);
  const resolvedTextTransform: TagTextTransform =
    textTransform || TAG_TEXT_TRANSFORM.UPPERCASE;
  const resolvedShape: UiShape = shape || UI_SHAPE.SQUARE;

  return (
    <$Tag
      disabled={disabled}
      $withoutMargin={withoutMargin}
      data-testid={dataTestId}
      $noEllispis={noEllispis}
      $fluid={fluid}
      $isNaked={isNaked}
      $size={resolvedSize}
      $variant={resolvedVariant}
      $shape={resolvedShape}
      role={role}
      $textTransform={resolvedTextTransform}
      $isHollow={isHollow}
      title={title}
      hasZIndex={hasZIndex}
    >
      <$TagContent onClick={onClick && onClick} $isClosable={Boolean(onClose)}>
        {children}
      </$TagContent>
      {onClose && (
        <$TagCloseButton
          type="button"
          onClick={onClose}
          aria-label="close-tag"
          disabled={disabled}
        >
          <CrossIcon size="12px" />
        </$TagCloseButton>
      )}
    </$Tag>
  );
};

export default Tag;
